import script from "./EventsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsTab.vue?vue&type=script&setup=true&lang=ts"

import "./EventsTab.vue?vue&type=style&index=0&id=5d7cdd9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d7cdd9d"]])

export default __exports__